import loadable from '@loadable/component';

// Lazy-loaded: react-easy-crop uses canvas (browser-only)
export const ProfilePhotoCrop = loadable(
  () => import(/* webpackChunkName: "ProfilePhotoCrop" */ './ProfilePhotoCrop')
);

export { default as translations } from './translations.json';
